module.exports = __webpack_public_path__ + "static/CoconutOil-8d7947c42df1b568c7ab1b5b93ec47e3.webp";